<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns" :class="!introductionContent.length ? 'column12 align-center' : 'column5'">
					<div class="title-reverse-wrapper">
						<h1>{{ title }}</h1>
						<h2 v-if="subtitle" class="subtitle" :class="!subtitle.length && 'no-after'">{{ subtitle }}</h2>
					</div>
				</div>
				<div class="columns column5">
					<div v-if="introductionContent.length" v-parse-links v-html="introductionContent" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
		<slot name="bgImage">
			<div />
		</slot>
	</section>
	<section v-if="content.length" class="main-content wide-content background-light">
		<div class="row">
			<div class="columns column8 align-left">
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</section>
	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introductionContent: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: flex-start;

	.align-center h1,
	.align-center h2 {
		margin-left: auto;
		margin-right: auto;
	}
}

.wide-content {
	padding-top: 0;

	.column8 {
		margin: 0 auto;
	}
}

.intro {
	.button:not(.button-accent),
	:deep(.button:not(.button-accent)) {
		background: none;
		border: 2px solid var(--button-nofill-color);
		color: var(--button-nofill-color);

		&:hover {
			background: var(--button-nofill-color);
			color: #fff;
		}
	}
}
</style>
